<template>
  <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
    <v-card :loading="loading" class="p-3 pt-0">
      <terminal-table v-model="selectedADS" :currentPage="datas.current_page"
                      :perPage="datas.per_page" v-if="isMobile" :getData="getData"
                      :pageCount="datas.last_page"
                      :options="tableProps" :datas="datas" :headers="columns">

        <template slot="filters">
          <!--          <v-autocomplete clearable clear-icon="mdi-close-circle-outline"-->
          <!--                          prepend-inner-icon="fa fa-pencil-alt" @change="changeStatus($event)" outlined-->
          <!--                          dense label="فیلتر وضعیت آگهی ها"-->
          <!--                          :items="status" item-text="name" item-value="name">-->
          <!--          </v-autocomplete>-->
        </template>
      </terminal-table>

      <data-table
          v-if="!isMobile"
          :data="datas"
          :columns="columns"
          :debounce-delay="3000"
          :translate="translate"
          :pagination="paginate"
          :orderBy="tableProps.column"
          :orderDir="tableProps.dir"
          :per-page="[10, 25, 50, 100, 500]"
          @on-table-props-changed="reloadTable"
          class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
      ></data-table>
    </v-card>
  </div>
</template>

<script>
import {Axios2, dataTableProps} from "@/main";
import button from "@/view/pages/button";
import {debounce} from "@/custom";

export default {
  name: "massRenewList",
  data() {
    return {
      AdsType: "",
      loading: false,
      selectedADS: [],
      result: {},
      mobile: false,
      provider: false,
      myStatus: '',
      finalReason: "",
      datas: {},
      translate: dataTableProps.translate,
      paginate: dataTableProps.pagination,
      tableProps: dataTableProps.tableProps,
      selectedNumber: [],
      dataId: '',
      telephoneNumber: '',
      Myseries: [],
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox" name="checkID"  data-id="${val.data.id}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.datas.current_page - 1;
            row = row * this.datas.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          transform: (val) => {
            const providers = {
              divar: 'شخصی',
              sheypoor: 'شخصی',
              divar_shop: 'فروشگاهی',
              divar_real_estate: 'املاک'
            };
            return `<div class="flex">${val.data.id}</br><p class="badge badge-info font-weight-bold p-1">${providers[val.data.provider]}</p></div>`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'شماره',
          name: 'number.phone',
          primary: true,
          transform: (val) => {
            return `${val.data.number.phone}  ${val.data.number.nickname != null ? val.data.number.nickname : ''}`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'موضوع',
          name: 'post.title',
          orderable: true,
          searchable: true,
        },
        {
          label: 'تاریخ نردبان',
          name: 'renew.available_at_p',
          orderable: true,
          searchable: true,
        },
      ],
    }

  },
  methods: {
    getData() {
      this.loading=true;
      Axios2.get(`divar/number/renew`).then((res) => {
        this.loading=false;
        this.datas = res.data.data;
      }).catch((err) => {
        this.loading=false;
        console.log('err in massRenew!');
      }).finally(()=>{
        this.loading=false;
      })

    },
    reloadTable() {
      debounce(() => {
        this.tableProps.page = this.datas.current_page;
        this.getData();
      }, 1000);
    },

  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getData();
          return true
        case 'sm':
          this.getData();
          return true
        case 'md':
          this.getData();
          return false
        case 'lg':
          this.getData();
          return false
        case 'xl':
          this.getData();
          return false
      }
    },
  },
  mounted() {
    this.tableProps.page = 1;
    this.getData();

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedADS = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedADS = []
      }
    });
    $(document).on('click', `input[name = 'checkID']`, (element) => {
      if ($(element.target).is(':checked')) {
        const selectedPart = $(element.target).data('id');
        console.log($(element.target))
        this.selectedADS.push(selectedPart);
      } else {
        $(element.target).prop('checked', false)
        this.selectedADS.splice(this.selectedADS.indexOf($(this).data('id')), 1)
      }
    });

  },
}
</script>

<style scoped>

</style>